const about = `# **Raccoon**

![DSC01356](https://user-images.githubusercontent.com/70361152/106779293-3378b200-668a-11eb-93e9-0e541dc23255.jpg)

언젠가부터 친구들이 '라쿤! 라쿤!' 하고 부른다.  
내가 라쿤 같다고 한다.  
잔머리, 엉뚱함, ~~귀여움(?)~~ 등이 이유란다.  
(어떤 어플에서 어울리는 동물 찾기 테스트 같은걸 했는데 '약삭빠른 너구리'인가 '능글능글 라쿤'인가가 나오긴 했다. '고독한 타이거' 같은게 나왔으면 좋았을텐데...)

![1492300177589](https://user-images.githubusercontent.com/70361152/106779292-3378b200-668a-11eb-9d70-ae016a9b12a9.jpg)

이건 친한 형에게 선물받은 일러스트인데...  
엄청 정성들이진 않고 살짝 끄적끄적해서 주는 것 같던데...  
고맙다 형~ 쫌 더 귀엽게 다시 그려주라~

---

## Photo

![DSC03549](https://user-images.githubusercontent.com/70361152/106779295-34114880-668a-11eb-8917-ab2d30448faa.jpg)

사진찍는게 좋다.  
셔터를 누르는 그 순간과 그 느낌,  
함께 있었던 사람, 그 사진에 담겨있는 사람,  
그리고 아름다운 풍경,  
이 모든 것을 렌즈에 담고, 눈에 담고, 마음에 담아  
소중한 추억이 되는  
그 순간들이 사랑스럽다.

![08220019](https://user-images.githubusercontent.com/70361152/106779288-32e01b80-668a-11eb-862f-46e28fd8ceda.jpg)
|                                                 응봉산 팔각정에서                                                  |

![08220047](https://user-images.githubusercontent.com/70361152/106779289-32e01b80-668a-11eb-91ce-d0f2105c077d.jpg)
|                                                    해질녘 남산                                                     |

![08120003](https://user-images.githubusercontent.com/70361152/106779280-31aeee80-668a-11eb-88db-3c053ea65e46.jpg)
|                                                    밤하늘의 별                                                     |

---

# Dream

작은 꿈이 있다.  
알리오 올리오 다 먹어보기.  
다이빙 포인트 정복해보기.  
다 이룰 수 없을지도 모른다.  
그래도 나는 꿈이 있다.

무지의 문을 열 때마다 하나의 세계가 열린다.  
몰랐던 장소에 가면 그곳의 역사가 내 앞에 펼쳐지고,  
몰랐던 음악을 들으면 또 하나의 감정이 내 맘에 펼쳐지고,  
몰랐던 사람을 만나면 바다같은 역사가 내 곁에 펼쳐진다.

---

# Coding

또 하나의 문을 두드렸다.
`;

export default about;
